import React, { useEffect, useRef, useState } from "react"
import Over_Thinking from "../audio/Over_Thinking.mp3"
import This_Misery from "../audio/THIS_MISERY_MASTER.mp3"
import Chemicals from "../audio/Chemicals_ProdRef2_DR_020626.mp3"
import KTR from "../audio/KTR_MASTER.mp3"
import Falling_Apart from "../audio/Falling_Apart.mp3"
import Black_and_blue from "../audio/Black_and_blue.mp3"
import Side_Winder from "../audio/Side_Winder.mp3"
import Burn from "../audio/Burn.mp3"

// includes unreleased tracks — this player only belongs on the EPK, never the public site
const TRACKS = [
    { title: "Over Thinking", src: Over_Thinking },
    { title: "This Misery", src: This_Misery },
    { title: "Chemicals", src: Chemicals },
    { title: "KTR", src: KTR },
    { title: "Falling Apart", src: Falling_Apart },
    { title: "Burn", src: Burn },
    { title: "Black And Blue", src: Black_and_blue },
    { title: "Side Winder", src: Side_Winder },
]

const formatTime = (seconds) => {
    if (!Number.isFinite(seconds)) return "0:00"
    const s = Math.floor(seconds)
    return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`
}

export const TrackPlayer = () => {
    const audioRef = useRef(null)
    const [currentIndex, setCurrentIndex] = useState(null)
    const [isPlaying, setIsPlaying] = useState(false)
    const [progress, setProgress] = useState({ current: 0, duration: 0 })

    // load and start a newly selected track
    useEffect(() => {
        const audio = audioRef.current
        if (!audio || currentIndex === null) return
        audio.src = TRACKS[currentIndex].src
        audio.play().catch(() => setIsPlaying(false))
    }, [currentIndex])

    const selectTrack = (index) => {
        const audio = audioRef.current
        if (index !== currentIndex) {
            setProgress({ current: 0, duration: 0 })
            setCurrentIndex(index)
        } else if (audio.paused) {
            audio.play()
        } else {
            audio.pause()
        }
    }

    const playNext = () => {
        if (currentIndex !== null && currentIndex < TRACKS.length - 1) {
            setCurrentIndex(currentIndex + 1)
        } else {
            setIsPlaying(false)
        }
    }

    const seek = (event) => {
        const audio = audioRef.current
        if (!audio || !progress.duration) return
        const rect = event.currentTarget.getBoundingClientRect()
        audio.currentTime = ((event.clientX - rect.left) / rect.width) * progress.duration
    }

    return (
        <>
            <audio
                ref={audioRef}
                onPlay={() => setIsPlaying(true)}
                onPause={() => setIsPlaying(false)}
                onEnded={playNext}
                onTimeUpdate={e => setProgress({ current: e.target.currentTime, duration: e.target.duration })}
                onLoadedMetadata={e => setProgress({ current: 0, duration: e.target.duration })}
            />
            <ul className="lf-tracks">
                {TRACKS.map((track, i) => {
                    const active = i === currentIndex
                    const playing = active && isPlaying
                    return (
                        <li key={track.title} className={active ? "lf-track lf-track--active" : "lf-track"}>
                            <button className="lf-track__row" onClick={() => selectTrack(i)} aria-label={`${playing ? "Pause" : "Play"} ${track.title}`}>
                                <span className="lf-track__n">{String(i + 1).padStart(2, "0")}</span>
                                <span className="lf-track__title">{track.title}</span>
                                <span className="lf-track__right">
                                    {playing && <span className="lf-wave" aria-hidden="true"><b></b><b></b><b></b><b></b><b></b></span>}
                                    {active && <span className="lf-track__time">{formatTime(progress.current)} / {formatTime(progress.duration)}</span>}
                                    <span className="lf-track__btn"><i className={playing ? "fas fa-pause" : "fas fa-play"}></i></span>
                                </span>
                            </button>
                            {active && (
                                <div className="lf-track__progress" onClick={seek}>
                                    <div style={{ width: `${progress.duration ? (progress.current / progress.duration) * 100 : 0}%` }}></div>
                                </div>
                            )}
                        </li>
                    )
                })}
            </ul>
        </>
    )
}
